import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ConfiguratorFacade } from '../../+state/configurator/configurator.facade';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { setStep, softReset } from '../../+state/configurator/configurator.actions';
import { slideFadeInBottom, slideInBottom } from '../../utils/animations/slide.animations';
import { IconSpriteModule } from 'ng-svg-icon-sprite';

@Component({
    selector: 'ncg-configurator-receipt',
    animations: [slideInBottom, slideFadeInBottom],
    template: ` <div class="container configurator__container" [@slideFadeInBottom]="{ value: '', params: { distance: '25px' } }">
        <div class="has-text-centered configurator__narrow">
            <span class="icon-wrapper">
                <svg-icon-sprite
                    [src]="'checkmark'"
                    [viewBox]="'0 0 30 30'"
                    [width]="'30px'"
                    [height]="'30px'"
                    aria-hidden="true"
                    class="is-flex icon"></svg-icon-sprite>
            </span>
            <h1 class="configurator__headline">{{ translationBase + 'heading_' + type | translate }}</h1>
            <p class="configurator__body-text mt-3">{{ translationBase + 'body_text_' + type | translate }}</p>
            <div class="buttons mt-5">
                <button class="button is-secondary" type="button" (click)="configuratorFacade.dispatch(softReset())">
                    {{ 'configurator.summary_reset' | translate }}
                </button>
                <button class="button is-primary" (click)="configuratorFacade.dispatch(setStep({ step: 'summary' }))">
                    {{ translationBase + 'button_see_configuration' | translate }}
                </button>
            </div>
        </div>
    </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./configurator-receipt.component.scss'],
    imports: [CommonModule, TranslateModule, IconSpriteModule],
})
export class ConfiguratorReceiptComponent {
    public translationBase = 'configurator.receipt_';
    public setStep = setStep;
    public softReset = softReset;

    @Input() type: 'to_me' | 'to_dealer';

    constructor(public readonly configuratorFacade: ConfiguratorFacade) {}
}
